module.exports = __webpack_public_path__ + "static/2-abf6d0de67b141acb013e504b970cbb4.png";